import React, { useContext } from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import Logo from 'components/Logo';
import { ValidacaoContext } from '../Context';

const useStyles = makeStyles((theme) => ({
  caption: {
    fontSize: theme.typography.pxToRem(16),
  },
}));

function Header() {
  const classes = useStyles();
  const { data } = useContext(ValidacaoContext);
  return (
    <>
      <Logo />
      <Typography component="h1" variant="h5" gutterBottom={false}>
        Validação de Certificados
      </Typography>
      {!data && (
      <Typography variant="caption" className={classes.caption}>
        Informe o código do documento para validação
      </Typography>
      )}
    </>
  );
}

export default Header;
